import { render, staticRenderFns } from "./Breadrumbs.vue?vue&type=template&id=58ec26fa&"
import script from "./Breadrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Breadrumbs.vue"
export default component.exports